import { useBlocksConfig } from "@pathwright/blocks-engine"
import { BlockText } from "@pathwright/blocks/src/shared"
import BackgroundImage from "@pathwright/ui/src/components/background/BackgroundImage"
import { Content } from "@pathwright/ui/src/components/content/Content"
import { BackgroundWrapper, Title, TitleDivider, TitleWrapper } from "./ui"

const TitleView = (props) => {
  const { layout, data } = props

  const { templateVariables } = useBlocksConfig()

  if (layout === "title") {
    return (
      <Content.Container>
        <TitleWrapper>
          <Title>
            <BlockText html={data.title} templateContext={templateVariables} />
          </Title>
          <TitleDivider />
        </TitleWrapper>
      </Content.Container>
    )
  }

  if (layout === "titleImage") {
    return (
      <BackgroundWrapper>
        <BackgroundImage image={data.image} overlay="rgba(0,0,0,0.3)" />
        <Content.Container>
          <TitleWrapper>
            <Title headingColor="white">
              <BlockText
                html={data.title}
                templateContext={templateVariables}
              />
            </Title>
          </TitleWrapper>
        </Content.Container>
      </BackgroundWrapper>
    )
  }

  return null
}

export default TitleView
